import { useTranslation } from 'react-i18next';

import { usePatientsSearchText, useUpdatePatientsSearchText } from '../../../../../features/patients';
import { Input } from '../../../../common';
import { BpStatusFilter, NewUserFilter, SyncStatusFilter } from './components';

export const PatientsHeader = () => {
  const { t } = useTranslation();
  const updateSearchText = useUpdatePatientsSearchText();
  const value = usePatientsSearchText();
  const onTextChange = (text: string) => updateSearchText(text);

  return (
    <div className="flex mb-6">
      <h3 className="typography-heading-large">{t('patients.title')}</h3>
      <div className="flex gap-4 ml-auto items-center">
        <Input
          type="search"
          value={value}
          onChange={onTextChange}
          className="min-w-[320px]"
          placeholder={t('patients.field.search.placeholder')}
        />
        <NewUserFilter />
        <SyncStatusFilter />
        <BpStatusFilter />
      </div>
    </div>
  );
};
